import React from 'react';
import { ATMForm, ATMRadio } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';

type IProps = {
  label: string;
  value?: boolean | null;
  no?: boolean;
  na?: boolean;
};

const FlagReadOnly: React.FC<IProps> = ({
  label,
  value,
  no = true,
  na = false,
}) => (
  <ATMForm.Field inline>
    <label>{label}</label>

    <div className="inline-block">
      <ATMForm.Group>
        <ATMForm.Field>
          <ATMRadio
            label={Lang.LBL_YES}
            value="yes"
            checked={value === true}
            readOnly
          />
        </ATMForm.Field>
        {no && (
          <ATMForm.Field>
            <ATMRadio
              label={Lang.LBL_NO}
              value="no"
              checked={value === false}
              readOnly
            />
          </ATMForm.Field>
        )}
        {na && (
          <ATMForm.Field>
            <ATMRadio
              label={Lang.LBL_NA}
              value="na"
              checked={value === null || value === false}
              readOnly
            />
          </ATMForm.Field>
        )}
      </ATMForm.Group>
    </div>
  </ATMForm.Field>
);

export default FlagReadOnly;
